import { Component } from 'vue-property-decorator';


import { Type } from "src/utils";

/**
 * 表示一个菜单权重。
 * @enum
 * @version 1.0.0
 */
enum MenuWeight
{
    /**
     * 系统权重。
     * @member
     */
    system = 1,

    /**
     * 业务权重
     * @member
     */
    business = 2
}

/*
* 定义枚举元数据。
*/
Type.setMetadata(MenuWeight,
{
    system:
    {
        alias: "系统权重",
        description: ""
    },
    business:
    {
        alias: "业务权重",
        description: ""
    }
});

export default MenuWeight;
